import { Component, OnInit, Inject } from '@angular/core';
import { TdLoadingService } from '@covalent/core';
import { MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';

import { Idea, IPaging, SuccessResponseObject } from '../../shared/index';
import { IdeaService } from '../../services/index';
import { AdminService } from '../../services/admin/admin.service';
import { PetitionAdminConfigs } from '../../shared/admin-models/interfaces/petition-admin-configs.interface';

@Component({
  selector: 'app-participant-list-dialog',
  templateUrl: './participant-list-dialog.component.html',
  styleUrls: ['./participant-list-dialog.component.scss']
})
export class ParticipantListDialogComponent implements OnInit {
  displayedColumns = ['id', 'firstName', 'lastName', 'createdAt'];
  dataSource = new MatTableDataSource();
  signersNeededAmount: number;

  /**
   * Constructor
   *
   * @param data
   * @param _loadingService
   * @param _ideaService
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Idea,
    private _loadingService: TdLoadingService,
    private _ideaService: IdeaService,
    private adminService: AdminService
  ) {}

  /**
   * Init
   */
  ngOnInit() {
    this.getSignerList(this.data.id);
  }
  getconfigs(): void {
    this.adminService.getConfigs().subscribe((res: PetitionAdminConfigs) => {
      this.signersNeededAmount = res.petitionCounterValue;
    });
  }
  /**
   * Gets signer list
   *
   * @param petitionId
   * @param paging
   */
  getSignerList(petitionId: number, paging: IPaging = null) {
    this._loadingService.register();
    this._ideaService
      .signerList({ petitionId }, paging)
      .finally(() => {
        this._loadingService.resolve();
      })
      .subscribe((res: any) => {
        if (res['errors']) {
          // console.log(res);
        } else if (res['result'].data) {
          this.dataSource = new MatTableDataSource(res['result'].data);
        }
      });
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/participant-list-dialog/participant-list-dialog.component.ts